// import moment from 'moment'
// const CustomDatePicker = (props) => {
//     return (<>
//         <input
//             type="date"
//             name=""
//             className="datepicker"
//             onChange={props.onChange} />
//         <div className="datepicker-overlay-custom">
//             {moment(props.value).format("DD/MM/YYYY")}
//         </div>
//     </>
//     )
// }
// export default CustomDatePicker
import moment from 'moment'
const CustomDatePicker = (props) => {
    // Check if value exists, otherwise show placeholder
    const displayDate = props.value
        ? moment(props.value).format("DD/MM/YYYY")
        : "DD/MM/YYYY";

    return (<>
        <input
            type="date"
            name=""
            className="datepicker"
                            value={props.value}

            // value={endDate}
            onChange={props.onChange} />
        <div className="datepicker-overlay-custom">
            {displayDate}
        </div>
    </>
    )
}
export default CustomDatePicker